import { useEffect, useState } from "react";
import { planApi } from "../../data/api/PlanApi";
import { Plan, SoulPlanModel } from "../../data/models/Plan/PlanModel";

export function usePlan() {
  const [plan, setPlan] = useState<SoulPlanModel | null>(null);
  const [plans, setPlans] = useState<Plan[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await planApi.getPlan.request(null);
        setPlans(res.data?.plans!);
        if (res.data?.soulPlan) setPlan(res?.data?.soulPlan);
      } catch (e) {
        setPlan(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { plan, loading, plans };
}
